import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";

// Dashboard pages
import Dashboard from "@/pages/Dashboard/Dashboard.vue";

// Pages
import User from "@/pages/Dashboard/Pages/UserProfile.vue";
import Pricing from "@/pages/Dashboard/Pages/Pricing.vue";
// import Login from "@/pages/Dashboard/Pages/Login.vue";
const Login = () => import("../pages/Dashboard/Pages/Login.vue");
import Register from "@/pages/Dashboard/Pages/Register.vue";
import Lock from "@/pages/Dashboard/Pages/Lock.vue";
import Settings from "@/pages/Dashboard/Pages/Settings.vue";
import Permissions from "@/pages/Dashboard/Pages/Permissions.vue";
import HrPermissions from "@/pages/Dashboard/Pages/HrPermissions/index.vue";
import users from "@/pages/Dashboard/Pages/main settings/users.vue";
import AdminStructure from "../pages/Dashboard/Pages/Administrative Affairs/AdminStructure.vue";
import Jobtitle from "@/pages/Dashboard/Pages/Administrative Affairs/Job title.vue";
import Staff_Reports from "@/pages/Dashboard/Pages/Administrative Affairs/Staff Reports.vue";
import employees from "@/pages/Dashboard/Pages/Administrative Affairs/employees.vue";
import new_employees from "@/pages/Dashboard/Pages/Administrative Affairs/employees/new_employees.vue";
import UserActivities from "@/pages/Dashboard/Pages/main settings/UserActivities.vue";
import Functionaldata from "@/pages/Dashboard/Pages/Administrative Affairs/employees/Functional data.vue";
import Financialdata from "@/pages/Dashboard/Pages/Administrative Affairs/employees/Financial data.vue";
import Qualifications from "@/pages/Dashboard/Pages/Administrative Affairs/employees/Qualifications.vue";
import Vacation from "@/pages/Dashboard/Pages/Administrative Affairs/employees/Vacation.vue";
import Assignment from "@/pages/Dashboard/Pages/Administrative Affairs/employees/Assignment.vue";
import JobStatus from "@/pages/Dashboard/Pages/Administrative Affairs/employees/JobStatus.vue";
import EmployeeDocuments from "@/pages/Dashboard/Pages/Administrative Affairs/employees/Employee Documents.vue";
import Takedown from "@/pages/Dashboard/Pages/Administrative Affairs/Takedown.vue";
import Efficiencies from "@/pages/Dashboard/Pages/Administrative Affairs/Efficiencies.vue";
import Branchclassification from "@/pages/Dashboard/Pages/Administrative Affairs/Branch classification.vue";
import situation from "@/pages/Dashboard/Pages/Administrative Affairs/settling the situation.vue";
import Deductions from "@/pages/Dashboard/Pages/Administrative Affairs/Deductions.vue";
import DashboardHR from "@/pages/Dashboard/Pages/Administrative Affairs/DashboardHR.vue";
import BackupSetting from "@/pages/Dashboard/Pages/BackupSetting/index.vue";

import employeeMovements from "@/pages/Dashboard/Pages/Administrative Affairs/employee movements.vue";
import employeePromotions from "@/pages/Dashboard/Pages/Administrative Affairs/employee promotions.vue";
import banks from "@/pages/Dashboard/Pages/menus/banks.vue";
import bankClassification from "@/pages/Dashboard/Pages/menus/bankClassification.vue";
import bankBranches from "@/pages/Dashboard/Pages/menus/Bank branches.vue";
import Signitures from "@/pages/Dashboard/Pages/menus/Signitures.vue";
import DeductionTypes from "@/pages/Dashboard/Pages/menus/DeductionTypes.vue";

import EmployeesAboutToUpgrade from "@/pages/Dashboard/Pages/DashboardTable/EmployeesAboutToUpgrade.vue";
import EmployeesAboutToUpgradeBonus from "@/pages/Dashboard/Pages/DashboardTable/EmployeesAboutToUpgradeBonus.vue";
import EndedServiceEmployees from "@/pages/Dashboard/Pages/DashboardTable/EndedServiceEmployees.vue";
import AbsentEmployees from "@/pages/Dashboard/Pages/DashboardTable/AbsentEmployees.vue";
import NewEmployees from "@/pages/Dashboard/Pages/DashboardTable/NewEmployees.vue";
import EmployeesAboutToEndService from "@/pages/Dashboard/Pages/DashboardTable/EmployeesAboutToEndService.vue";
import DesignationEmployees from "@/pages/Dashboard/Pages/DashboardTable/DesignationEmployees.vue";
import ContractEmployees from "@/pages/Dashboard/Pages/DashboardTable/ContractEmployees.vue";
import DelegationEmployees from "@/pages/Dashboard/Pages/DashboardTable/DelegationEmployees.vue";
import LoanEmployees from "@/pages/Dashboard/Pages/DashboardTable/LoanEmployees.vue";
import ClassifiedContractEmployees from "@/pages/Dashboard/Pages/DashboardTable/ClassifiedContractEmployees.vue";
import CooperativeContractEmployees from "@/pages/Dashboard/Pages/DashboardTable/CooperativeContractEmployees.vue";
import NonJobTypeEmployees from "@/pages/Dashboard/Pages/DashboardTable/NonJobTypeEmployees.vue";
import EmployeesGotMaximumAbsenceLimit from "@/pages/Dashboard/Pages/DashboardTable/EmployeesGotMaximumAbsenceLimit.vue";
import OverTimeEmployees from "@/pages/Dashboard/Pages/DashboardTable/OverTimeEmployees.vue";

import Types_of_bonuses from "@/pages/Dashboard/Pages/menus/Types of bonuses.vue";
import Nationality from "@/pages/Dashboard/Pages/menus/Nationality.vue";
import types_of_documents from "@/pages/Dashboard/Pages/menus/types of documents.vue";
import Types_of_reviews from "@/pages/Dashboard/Pages/menus/Types of reviews.vue";
import types_of_vacations from "@/pages/Dashboard/Pages/menus/types of vacations.vue";
import menus_Qualifications from "@/pages/Dashboard/Pages/menus/Qualifications.vue";

import TypesOfRewards from "@/pages/Dashboard/Pages/menus/TypesOfRewards.vue";

import Courts from "@/pages/Dashboard/Pages/menus/Courts.vue";
import shifts from "@/pages/Dashboard/Pages/Attendance and Departure/shifts.vue";
import PresentTable from "@/pages/Dashboard/Pages/Attendance and Departure/PresentTable.vue";
import Attendance from "@/pages/Dashboard/Pages/Attendance and Departure/Attendance.vue";
import LeavePermission from "@/pages/Dashboard/Pages/Attendance and Departure/LeavePermission.vue";
import ManagingTimeSheet from "@/pages/Dashboard/Pages/Attendance and Departure/ManagingTimeSheet.vue";
import WorkPlaces from "@/pages/Dashboard/Pages/Attendance and Departure/WorkPlaces.vue";

import holidays from "@/pages/Dashboard/Pages/monthly variables/holidays.vue";
import newHolidays from "@/pages/Dashboard/Pages/monthly variables/new holidays.vue";
import employee_bonuses from "@/pages/Dashboard/Pages/monthly variables/employee bonuses.vue";
import Vacation_requests from "@/pages/Dashboard/Pages/monthly variables/Vacation requests.vue";
import Rewards from "@/pages/Dashboard/Pages/monthly variables/Rewards.vue";
import State_holidays from "@/pages/Dashboard/Pages/monthly variables/State holidays.vue";
import excuses from "@/pages/Dashboard/Pages/monthly variables/excuses.vue";
import newExcuses from "@/pages/Dashboard/Pages/monthly variables/new excuses.vue";
import reviews from "@/pages/Dashboard/Pages/monthly variables/reviews.vue";
import newreviews from "@/pages/Dashboard/Pages/monthly variables/new reviews.vue";
import Committees from "@/pages/Dashboard/Pages/monthly variables/Committees.vue";
import new_Committees from "@/pages/Dashboard/Pages/monthly variables/new Committees.vue";
import Attendance_Departure from "@/pages/Dashboard/Pages/monthly variables/Attendance and Departure.vue";
import Financial_grades from "@/pages/Dashboard/Pages/salaries/Financial grades.vue";
import salary from "@/pages/Dashboard/Pages/salaries/salary.vue";
import confirm_salary from "@/pages/Dashboard/Pages/salaries/confirm salary.vue";
import details_salary from "@/pages/Dashboard/Pages/salaries/details salary.vue";
import Extra_work from "@/pages/Dashboard/Pages/salaries/Extra work.vue";
import salary_Table from "@/pages/Dashboard/Pages/salaries/salary Table.vue";
import differences from "@/pages/Dashboard/Pages/salaries/differences.vue";
import salary_comparison from "@/pages/Dashboard/Pages/salaries/salary comparison.vue";
import Salary_Reports from "@/pages/Dashboard/Pages/salaries/Salary Reports.vue";
import Salary_Reports_Show from "@/pages/Dashboard/Pages/salaries/Salary Reports Show.vue";
import Sanctions from "@/pages/Dashboard/Pages/menus/Sanctions.vue";
import TypesOfTasks from "@/pages/Dashboard/Pages/Tasks/TypesOfTasks.vue";
import TasksSchedule from "@/pages/Dashboard/Pages/Tasks/TasksSchedule/TasksSchedule.vue";
import TasksScheduleList from "@/pages/Dashboard/Pages/Tasks/TasksSchedule/TasksScheduleList.vue";
import TasksScheduleDetails from "@/pages/Dashboard/Pages/Tasks/TasksSchedule/TasksScheduleDetails.vue";

// Components pages
import Buttons from "@/pages/Dashboard/Components/Buttons.vue";
import GridSystem from "@/pages/Dashboard/Components/GridSystem.vue";
import Panels from "@/pages/Dashboard/Components/Panels.vue";
import SweetAlert from "@/pages/Dashboard/Components/SweetAlert.vue";
import Notifications from "@/pages/Dashboard/Components/Notifications.vue";
import Icons from "@/pages/Dashboard/Components/Icons.vue";
import Typography from "@/pages/Dashboard/Components/Typography.vue";

// Forms pages
import RegularForms from "@/pages/Dashboard/Forms/RegularForms.vue";
import ExtendedForms from "@/pages/Dashboard/Forms/ExtendedForms.vue";
import ValidationForms from "@/pages/Dashboard/Forms/ValidationForms.vue";
import Wizard from "@/pages/Dashboard/Forms/Wizard.vue";

// TableList pages
import RegularTables from "@/pages/Dashboard/Tables/RegularTables.vue";
import ExtendedTables from "@/pages/Dashboard/Tables/ExtendedTables.vue";
import PaginatedTables from "@/pages/Dashboard/Tables/PaginatedTables.vue";

// Maps pages
import GoogleMaps from "@/pages/Dashboard/Maps/GoogleMaps.vue";
import FullScreenMap from "@/pages/Dashboard/Maps/FullScreenMap.vue";
import VectorMaps from "@/pages/Dashboard/Maps/VectorMaps.vue";

// Calendar
import Calendar from "@/pages/Dashboard/Calendar.vue";
// Charts
import Charts from "@/pages/Dashboard/Charts.vue";
import Widgets from "@/pages/Dashboard/Widgets.vue";

import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

let componentsMenu = {
  path: "/components",
  component: DashboardLayout,
  meta: {
    IsAuth: true,
  },
  redirect: "/components/buttons",
  name: "Components",
  children: [
    {
      path: "buttons",
      name: "Buttons",
      components: {
        default: Buttons,
      },
    },
    {
      path: "grid-system",
      name: "Grid System",
      components: {
        default: GridSystem,
      },
    },
    {
      path: "panels",
      name: "Panels",
      components: {
        default: Panels,
      },
    },
    {
      path: "sweet-alert",
      name: "Sweet Alert",
      components: {
        default: SweetAlert,
      },
    },
    {
      path: "notifications",
      name: "Notifications",
      components: {
        default: Notifications,
      },
    },
    {
      path: "icons",
      name: "Icons",
      components: {
        default: Icons,
      },
    },
    {
      path: "typography",
      name: "Typography",
      components: {
        default: Typography,
      },
    },
  ],
};
let formsMenu = {
  path: "/forms",
  component: DashboardLayout,
  redirect: "/forms/regular",
  name: "Forms",
  meta: {
    IsAuth: true,
  },
  children: [
    {
      path: "regular",
      name: "Regular Forms",
      components: {
        default: RegularForms,
      },
    },
    {
      path: "extended",
      name: "Extended Forms",
      components: {
        default: ExtendedForms,
      },
    },
    {
      path: "validation",
      name: "Validation Forms",
      components: {
        default: ValidationForms,
      },
    },
    {
      path: "wizard",
      name: "Wizard",
      components: {
        default: Wizard,
      },
    },
  ],
};

let tablesMenu = {
  path: "/table-list",
  component: DashboardLayout,
  meta: {
    IsAuth: true,
  },
  redirect: "/table-list/regular",
  name: "Tables",

  children: [
    {
      path: "regular",
      name: "Regular Tables",
      components: {
        default: RegularTables,
      },
    },
    {
      path: "extended",
      name: "Extended Tables",
      components: {
        default: ExtendedTables,
      },
    },
    {
      path: "paginated",
      name: "Pagianted Tables",
      components: {
        default: PaginatedTables,
      },
    },
  ],
};

let mapsMenu = {
  path: "/maps",
  component: DashboardLayout,
  name: "Maps",
  meta: {
    IsAuth: true,
  },
  redirect: "/maps/google",
  children: [
    {
      path: "google",
      name: "Google Maps",
      components: {
        default: GoogleMaps,
      },
    },
    {
      path: "full-screen",
      name: "Full Screen Map",
      meta: {
        hideContent: true,
        hideFooter: true,
        navbarAbsolute: true,
      },
      components: {
        default: FullScreenMap,
      },
    },
    {
      path: "vector-map",
      name: "Vector Map",
      components: {
        default: VectorMaps,
      },
    },
  ],
};

let pagesMenu = {
  path: "/pages",
  component: DashboardLayout,
  name: "",
  meta: {
    IsAuth: true,
    rtlActive: true,
  },
  redirect: "/pages/users",
  children: [
    {
      path: "/pages/user",
      name: "",
      components: {
        default: User,
      },
    },
    {
      path: "/pages/Permissions",
      name: "",
      meta: {
        rtlActive: true,
        title: "الصلاحيات",
      },
      components: {
        default: HrPermissions,
        // default: Permissions,
      },
    },
    {
      path: "/pages/hr-permissions",
      name: "",
      meta: {
        rtlActive: true,
        title: "الصلاحيات",
      },
      components: {
        default: HrPermissions,
      },
    },
    {
      path: "/pages/Settings",
      name: "",
      components: {
        default: Settings,
      },
      meta: {
        rtlActive: true,
        title: "إعدادات النظام",
      },
    },
    {
      path: "/pages/users",
      name: "",
      meta: {
        rtlActive: true,
        title: "المستخدمين",
      },

      components: {
        default: users,
      },
    },
    {
      path: "/pages/organization_structure",
      name: "",
      meta: {
        rtlActive: true,
        title: "الهيكلية الإدارية",
      },
      components: {
        default: AdminStructure,
      },
    },
    {
      path: "/pages/Job_title",
      name: "",
      meta: {
        rtlActive: true,
        title: "الصفة الوظيفية",
      },
      components: {
        default: Jobtitle,
      },
    },

    {
      path: "/pages/Staff_Reports",
      name: "",
      meta: {
        rtlActive: true,
        title: "تقارير الموظفين",
      },
      components: {
        default: Staff_Reports,
      },
    },

    {
      path: "/pages/employees",
      name: "",
      meta: {
        rtlActive: true,
        title: "الموظفين",
      },
      components: {
        default: employees,
      },
    },
    {
      path: "/pages/employee/info/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: new_employees,
      },
    },
    {
      path: "/pages/UserActivities",
      name: "",
      meta: {
        rtlActive: true,
        title: "أنشطة المستخدمين",
      },
      components: {
        default: UserActivities,
      },
    },

    {
      path: "/pages/employee/Functionaldata/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: Functionaldata,
      },
    },

    {
      path: "/pages/employee/Financialdata/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: Financialdata,
      },
    },

    {
      path: "/pages/employee/Certifications/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: Qualifications,
      },
    },

    {
      path: "/pages/employee/Vacation/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: Vacation,
      },
    },

    {
      path: "/pages/employee/Assignment/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: Assignment,
      },
    },

    {
      path: "/pages/employee/JobStatus/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: JobStatus,
      },
    },

    {
      path: "/pages/employee/EmployeeDocuments/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: EmployeeDocuments,
      },
    },

    {
      path: "/pages/end_of_service",
      name: "",
      meta: {
        rtlActive: true,
        title: "إنتهاء الخدمة",
      },
      components: {
        default: Takedown,
      },
    },

    {
      path: "/pages/Efficiencies",
      name: "",
      meta: {
        rtlActive: true,
        title: "تقييمات الموظف",
      },
      components: {
        default: Efficiencies,
      },
    },

    {
      path: "/pages/branch_classification",
      name: "",
      meta: {
        rtlActive: true,
        title: "تصنيف الفروع",
      },
      components: {
        default: Branchclassification,
      },
    },

    {
      path: "/pages/job_stages",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: situation,
      },
    },

    {
      path: "/pages/Deductions",
      name: "",
      meta: {
        rtlActive: true,
        title: "الإستقطاعات",
      },
      components: {
        default: Deductions,
      },
    },

    {
      path: "/pages/DashboardHR",
      name: "",
      meta: {
        rtlActive: true,
        title: "التقارير التفاعلية",
      },
      components: {
        default: DashboardHR,
      },
    },
    {
      path: "/pages/backup",
      name: "",
      meta: {
        rtlActive: true,
        title: "النسخ الاحتياطي",
      },
      components: {
        default: BackupSetting,
      },
    },

    {
      path: "/pages/employee_transactions",
      name: "",
      meta: {
        rtlActive: true,
        title: "حركات الموظفين",
      },
      components: {
        default: employeeMovements,
      },
    },

    {
      path: "/pages/employee_promotion_transactions",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: employeePromotions,
      },
    },

    {
      path: "/pages/banks",
      name: "",
      meta: {
        rtlActive: true,
        title: "المصارف",
      },
      components: {
        default: banks,
      },
    },

    {
      path: "/pages/bankClassification",
      name: "",
      meta: {
        rtlActive: true,
        title: "تصنيف فروع المصارف",
      },
      components: {
        default: bankClassification,
      },
    },

    {
      path: "/pages/Bank-branches",
      name: "",
      meta: {
        rtlActive: true,
        title: "فروع المصارف",
      },
      components: {
        default: bankBranches,
      },
    },

    {
      path: "/pages/EmployeesAboutToUpgrade",
      name: "",
      meta: {
        rtlActive: true,
        title: "",
      },
      components: {
        default: EmployeesAboutToUpgrade,
      },
    },

    {
      path: "/pages/EmployeesAboutToUpgradeBonus",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: EmployeesAboutToUpgradeBonus,
      },
    },

    {
      path: "/pages/EndedServiceEmployees/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: EndedServiceEmployees,
      },
    },

    {
      path: "/pages/AbsentEmployees/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: AbsentEmployees,
      },
    },

    {
      path: "/pages/NewEmployees/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: NewEmployees,
      },
    },

    {
      path: "/pages/EmployeesAboutToEndService/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: EmployeesAboutToEndService,
      },
    },

    {
      path: "/pages/DesignationEmployees/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: DesignationEmployees,
      },
    },

    {
      path: "/pages/ContractEmployees/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: ContractEmployees,
      },
    },

    {
      path: "/pages/DelegationEmployees/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: DelegationEmployees,
      },
    },

    {
      path: "/pages/LoanEmployees/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: LoanEmployees,
      },
    },

    {
      path: "/pages/ClassifiedContractEmployees/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: ClassifiedContractEmployees,
      },
    },

    {
      path: "/pages/CooperativeContractEmployees/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: CooperativeContractEmployees,
      },
    },

    {
      path: "/pages/NonJobTypeEmployees/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: NonJobTypeEmployees,
      },
    },

    {
      path: "/pages/EmployeesGotMaximumAbsenceLimit/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: EmployeesGotMaximumAbsenceLimit,
      },
    },

    {
      path: "/pages/OverTimeEmployees/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: OverTimeEmployees,
      },
    },

    {
      path: "/pages/Signitures",
      name: "",
      meta: {
        rtlActive: true,
        title: "التوقيعات",
      },
      components: {
        default: Signitures,
      },
    },

    {
      path: "/pages/types_of_allowance",
      name: "",
      meta: {
        rtlActive: true,
        title: "أنواع العلاوات",
      },
      components: {
        default: Types_of_bonuses,
      },
    },

    {
      path: "/pages/Nationalities",
      name: "",
      meta: {
        rtlActive: true,
        title: "الجنسيات",
      },
      components: {
        default: Nationality,
      },
    },

    {
      path: "/pages/deduction-types",
      name: "",
      meta: {
        rtlActive: true,
        title: "أنواع الاستقطاعات",
      },
      components: {
        default: DeductionTypes,
      },
    },

    {
      path: "/pages/types-of-documents",
      name: "",
      meta: {
        rtlActive: true,
        title: "أنواع المستندات",
      },
      components: {
        default: types_of_documents,
      },
    },

    {
      path: "/pages/types_of_evaluation",
      name: "",
      meta: {
        rtlActive: true,
        title: "أنواع التقييمات",
      },
      components: {
        default: Types_of_reviews,
      },
    },

    {
      path: "/pages/types-of-vacations",
      name: "",
      meta: {
        rtlActive: true,
        title: "أنواع الإجازات",
      },
      components: {
        default: types_of_vacations,
      },
    },

    {
      path: "/pages/TypesOfRewards",
      name: "",
      meta: {
        rtlActive: true,
        title: "أنواع المكافآت",
      },
      components: {
        default: TypesOfRewards,
      },
    },

    {
      path: "/pages/Certifications",
      name: "",
      meta: {
        rtlActive: true,
        title: "المؤهلات العلمية",
      },
      components: {
        default: menus_Qualifications,
      },
    },

    {
      path: "/pages/Courts",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: Courts,
      },
    },

    {
      path: "/pages/shifts",
      name: "",
      meta: {
        rtlActive: true,
        title: "دوام العمل",
      },
      components: {
        default: shifts,
      },
    },

    {
      path: "/pages/TimeSheet",
      name: "",
      meta: {
        rtlActive: true,
        title: "جدول الحضور والانصراف",
      },
      components: {
        default: PresentTable,
      },
    },

    {
      path: "/pages/attendance",
      name: "",
      meta: {
        rtlActive: true,
        title: "سجل الحضور والانصراف",
      },
      components: {
        default: Attendance,
      },
    },

    {
      path: "/pages/leave-permission",
      name: "",
      meta: {
        rtlActive: true,
        title: "أذونات الخروج",
      },
      components: {
        default: LeavePermission,
      },
    },

    {
      path: "/pages/ManagingTimeSheet",
      name: "",
      meta: {
        rtlActive: true,
        title: "إدارة أجهزة الحضور والانصراف",
      },
      components: {
        default: ManagingTimeSheet,
      },
    },
    {
      path: "/pages/work-places",
      name: "",
      meta: {
        rtlActive: true,
        title: "أماكن العمل",
      },
      components: {
        default: WorkPlaces,
      },
    },

    {
      path: "/pages/vacations",
      name: "",
      meta: {
        rtlActive: true,
        title: "الإجازات",
      },
      components: {
        default: holidays,
      },
    },

    {
      path: "/pages/vacation/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: newHolidays,
      },
    },

    {
      path: "/pages/employee_allowances",
      name: "",
      meta: {
        rtlActive: true,
        title: "علاوات الموظفين",
      },
      components: {
        default: employee_bonuses,
      },
    },

    {
      path: "/pages/vacation_requests",
      name: "",
      meta: {
        rtlActive: true,
        title: "طلبات الإجازات",
      },
      components: {
        default: Vacation_requests,
      },
    },

    {
      path: "/pages/Rewards",
      name: "",
      meta: {
        rtlActive: true,
        title: "المكافآت",
      },
      components: {
        default: Rewards,
      },
    },
    {
      path: "/pages/holidays",
      name: "",
      meta: {
        rtlActive: true,
        title: "العطل",
      },
      components: {
        default: State_holidays,
      },
    },

    {
      path: "/pages/excuses",
      name: "",
      meta: {
        rtlActive: true,
        title: "الأعذار",
      },
      components: {
        default: excuses,
      },
    },

    {
      path: "/pages/Excuses/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: newExcuses,
      },
    },

    {
      path: "/pages/evaluation",
      name: "",
      meta: {
        rtlActive: true,
        title: "التقييمات",
      },
      components: {
        default: reviews,
      },
    },

    {
      path: "/pages/evaluation/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: newreviews,
      },
    },

    {
      path: "/pages/Committees",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: Committees,
      },
    },

    {
      path: "/pages/Committees/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: new_Committees,
      },
    },

    {
      path: "/pages/Time-sheet",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: Attendance_Departure,
      },
    },

    {
      path: "/pages/Financial_grades",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: Financial_grades,
      },
    },

    {
      path: "/pages/salary",
      name: "",
      meta: {
        rtlActive: true,
        title: "إعداد المرتبات",
      },
      components: {
        default: salary,
      },
    },

    {
      path: "/pages/confirm_salary",
      name: "",
      meta: {
        rtlActive: true,
        title: "اعتماد المرتبات",
      },
      components: {
        default: confirm_salary,
      },
    },

    {
      path: "/pages/details_salary/:id",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: details_salary,
      },
    },

    {
      path: "/pages/OverTime",
      name: "",
      meta: {
        rtlActive: true,
        title: "العمل الإضافي",
      },
      components: {
        default: Extra_work,
      },
    },

    {
      path: "/pages/salary_Table",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: salary_Table,
      },
    },

    {
      path: "/pages/differences",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: differences,
      },
    },

    {
      path: "/pages/salary_comparison",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: salary_comparison,
      },
    },

    {
      path: "/pages/Salary_Reports",
      name: "",
      meta: {
        rtlActive: true,
        title: "تقارير المرتبات",
      },
      components: {
        default: Salary_Reports,
      },
    },

    {
      path: "/pages/Salary_Reports/Show",
      name: "",
      meta: {
        rtlActive: true,
      },
      components: {
        default: Salary_Reports_Show,
      },
    },

    {
      path: "/pages/attendance-Deductions",
      name: "",
      meta: {
        rtlActive: true,
        title: "الجزاءات",
      },
      components: {
        default: Sanctions,
      },
    },
    {
      path: "/pages/types-of-tasks",
      name: "",
      meta: {
        rtlActive: true,
        title: "أنواع المهام",
      },
      components: {
        default: TypesOfTasks,
      },
    },
    {
      path: "/pages/tasks-schedule",
      name: "",
      meta: {
        rtlActive: true,
        title: "جدول المهام",
      },
      components: {
        default: TasksSchedule,
      },
    },
    {
      path: "/pages/tasks-schedule/new",
      name: "",
      meta: {
        rtlActive: true,
        title: "جدول المهام | جديد",
      },
      components: {
        default: TasksScheduleList,
      },
    },
    {
      path: "/pages/tasks-schedule/:id",
      name: "",
      meta: {
        rtlActive: true,
        title: "جدول المهام | تفاصيل",
      },
      components: {
        default: TasksScheduleDetails,
      },
    },
  ],
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  meta: {
    IsAuth: false,
  },
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
    },

    {
      path: "/register",
      name: "Register",
      component: Register,
    },

    {
      path: "/pricing",
      name: "Pricing",
      component: Pricing,
    },
    {
      path: "/lock",
      name: "Lock",
      component: Lock,
    },
  ],
};

// new Router({

const routes = [
  {
    path: "/",
    redirect: "/login",
  },

  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  authPages,
  {
    path: "/",
    component: DashboardLayout,
    meta: {
      IsAuth: true,
    },
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        components: {
          default: Dashboard,
        },
        meta: {
          rtlActive: true,
          IsAuth: true,
        },
      },
      {
        path: "calendar",
        name: "Calendar",
        components: {
          default: Calendar,
        },
      },
      {
        path: "charts",
        name: "Charts",
        components: {
          default: Charts,
        },
      },
      {
        path: "widgets",
        name: "Widgets",
        components: {
          default: Widgets,
        },
      },
    ],
  },
];
export default routes;
